import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";

export default function Enquire() {
    const navigate = useNavigate();
    const [showWhatsapp, setShowWhatsapp] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setShowWhatsapp((prev) => !prev);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="floating-btn-container">
            {/* Enquiry Button */}

            <a
                href="/contact"
                className={`floating-btn ${showWhatsapp ? "fade-out" : "fade-in"
                    }`}
            >

                <span className="whatsapp-btn">Enquire for Bulk Order</span>
            </a>

            {/* WhatsApp Button */}
            <a
                href="https://wa.me/917398333330?text=Hi%20I%20want%20to%20enquire%20about%20bulk%20orders"
                target="_blank"
                rel="noopener noreferrer"
                className={`floating-btn ${showWhatsapp ? "fade-in" : "fade-out"
                    }`}
            >
                <span className="whatsapp-btn">
                    <FaWhatsapp size={20} className="me-2" />
                    Chat on WhatsApp</span>
            </a>
        </div>
    );
}
